<form [formGroup]="form" class="flex-between-center flex-direction-row">
  @if (showButtons) {
    <div class="width-button">
      <button mat-mini-fab color="primary" (click)="clickbefore()">
        <mat-icon>chevron_left</mat-icon>
      </button>
    </div>
  }
  <mat-form-field
    [ngClass]="[classStyle,showButtons?'width-select':'w100']"
    [appearance]="appearance"
    (focusout)="focusOut()"
    >
    <mat-label>&nbsp;&nbsp;{{ title }}</mat-label>
    <input
      #autoCompleteInput
      matInput
      formControlName="autoComplete"
      (blur)="onTouched()"
      [matAutocomplete]="autoItems"
      >
    <mat-autocomplete #autoItems="matAutocomplete"
      [displayWith]="displayFnNumeroQuadro.bind(this)"
      (optionSelected)="emitOptionSelected($event)"

      >

      @for (group of filteredOptionsGroup|async;track group){
        <mat-optgroup [label]="group.groupName">
          @for (option of group.possibleValues; track option) {
            <mat-option class="flex-between-center" [value]="option.valueForm"
              >
              @if (option.icon) {
                <ng-template

                  [ngTemplateOutlet]="ICON"
                  [ngTemplateOutletContext]="option.icon"
                  >
                </ng-template>
              }
              @if (option.sensorEventTraduction) {
                {{ (option.sensorEventTraduction|sensorDataTraduction$)|async }}
              } @else if (option.traductions) {
                @for (traduction of option.traductions; track traduction) {
                  {{ traduction|translate }}
                }
              } @else if (option.traduction) {
                {{ option.traduction|translate }}
              } @else {
                {{ option.html }}
              }
            </mat-option>
          }
        </mat-optgroup>
      }
      @for (option of filteredOptions | async; track option) {
        <mat-option class="flex-between-center"
          [value]="option.valueForm"
          >
          @if (option.icon) {
            <ng-template
              [ngTemplateOutlet]="ICON"
              [ngTemplateOutletContext]="option.icon"
              >
            </ng-template>
          }
          @if (option.sensorEventTraduction) {
            {{ (option.sensorEventTraduction|sensorDataTraduction$)|async }}
          } @else if (option.traductions) {
            @for (traduction of option.traductions; track traduction) {
              {{ traduction|translate }}
            }
          } @else if (option.traduction) {
            {{ option.traduction|translate }}
          } @else {
            {{ option.html }}
          }
        </mat-option>
      }

    </mat-autocomplete>

    @if (!hiddenClearButton) {
      <button mat-icon-button matSuffix (click)="$event.stopPropagation();resetForm()"
        [disabled]="form.disabled">
        <mat-icon>clear</mat-icon>
      </button>
    }
    <span matPrefix>
      <ng-content select="[prefix]">
      </ng-content>
    </span>
    <div matSuffix>
      <ng-content select="[suffix]">
      </ng-content>
    </div>
  </mat-form-field>
  @if (showButtons) {
    <div class="width-button" (click)="clickNext()">
      <button mat-mini-fab color="primary">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
  }
</form>

<ng-template #ICON let-svgName="svgName" let-iconName="iconName" let-color="color">
  @if (svgName) {
    <mat-icon style="margin-bottom: -5px" [svgIcon]="svgName" [color]="color"></mat-icon>
  } @else {
    <mat-icon style="margin-bottom: -5px" [color]="color">{{ iconName }}</mat-icon>
  }
</ng-template>